import React from 'react';

/**
 * サイト共通の線アイコン。
 * 48x48 / stroke-width 2 で統一し、currentColor を継承させる。
 * アイコンフォントを使わないのは、線の太さと余白を揃えて全体の質感を保つため。
 */
type IconProps = { className?: string };

const base = (children: React.ReactNode) => {
  const Icon: React.FC<IconProps> = ({ className }) => (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
  return Icon;
};

/** 記帳：帳簿とチェック */
export const IconLedger = base(
  <>
    <path d="M11 9a3 3 0 0 1 3-3h20a3 3 0 0 1 3 3v30a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V9Z" />
    <path d="M11 14h26M18 6v8" />
    <path d="m19 27 4 4 8-8" stroke="#F26B21" />
    <path d="M18 36h12" />
  </>
);

/** 決算：書類と計算 */
export const IconStatement = base(
  <>
    <path d="M12 8a2 2 0 0 1 2-2h13l9 9v25a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2V8Z" />
    <path d="M27 6v9h9" />
    <path d="M18 26h12M18 32h8" />
    <circle cx="33" cy="33" r="7" fill="#FFFFFF" stroke="#F26B21" />
    <path d="m30 33 2 2 4-4" stroke="#F26B21" />
  </>
);

/** 集計：棒グラフ */
export const IconChart = base(
  <>
    <path d="M8 40h32" />
    <rect x="12" y="26" width="6" height="14" rx="1.5" />
    <rect x="22" y="18" width="6" height="22" rx="1.5" />
    <rect x="32" y="10" width="6" height="30" rx="1.5" stroke="#F26B21" />
  </>
);

/** 自然言語入力：吹き出しとスパーク */
export const IconChatAi = base(
  <>
    <path d="M8 15a5 5 0 0 1 5-5h22a5 5 0 0 1 5 5v14a5 5 0 0 1-5 5H21l-9 8v-8a4 4 0 0 1-4-4V15Z" />
    <path d="m24 15 1.8 4.2L30 21l-4.2 1.8L24 27l-1.8-4.2L18 21l4.2-1.8L24 15Z" stroke="#F26B21" />
  </>
);

/** セキュリティ：盾と鍵 */
export const IconShield = base(
  <>
    <path d="M24 5 9 11v12c0 10 6.4 18.6 15 21 8.6-2.4 15-11 15-21V11L24 5Z" />
    <rect x="19" y="23" width="10" height="9" rx="2" stroke="#F26B21" />
    <path d="M21 23v-3a3 3 0 0 1 6 0v3" stroke="#F26B21" />
  </>
);

/** 時間削減：時計と矢印 */
export const IconClock = base(
  <>
    <circle cx="24" cy="25" r="15" />
    <path d="M24 16v9l6 4" />
    <path d="M18 7h12" />
    <path d="m36 12 4-4" stroke="#F26B21" />
  </>
);

/** ローカル保存：PC本体 */
export const IconDesktop = base(
  <>
    <rect x="7" y="9" width="34" height="24" rx="3" />
    <path d="M18 41h12M24 33v8" />
    <path d="M14 16h8M14 22h14" stroke="#F26B21" />
  </>
);

/** OCR：レシート読み取り */
export const IconScan = base(
  <>
    <path d="M14 8h20a2 2 0 0 1 2 2v30l-4-3-4 3-4-3-4 3-4-3-4 3V10a2 2 0 0 1 2-2Z" />
    <path d="M19 18h10M19 25h6" />
    <path d="M8 4h4M44 4h-4M8 44h4M44 44h-4" stroke="#F26B21" />
  </>
);

/** コスト：円マーク */
export const IconYen = base(
  <>
    <circle cx="24" cy="24" r="17" />
    <path d="m17 16 7 10 7-10" />
    <path d="M17 28h14M17 33h14M24 26v11" stroke="#F26B21" />
  </>
);

/** サポート：人と吹き出し */
export const IconSupport = base(
  <>
    <circle cx="24" cy="17" r="7" />
    <path d="M11 40c0-7.2 5.8-13 13-13s13 5.8 13 13" />
    <path d="M36 10h6a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3l-3 3v-3" stroke="#F26B21" />
  </>
);
